"use strict";
var React = require("react");
// var flex = require("./_flex");

import SubmitModal from './components/modals/SubmitModal';
import PrismSubmitModal from './components/modals/PrismSubmitModal';
import InfoModal from './components/modals/InfoModal';
import SpinnerModal from './components/modals/SpinnerModal';
import loaders from './components/loaders';
import { default as initOAuthCallback } from "./authentication/oauthCallback";
import UnsavedChangesPrompt from './components/unsavedChangesPrompt';
import CronFormatter from './components/cronFormatter';
import utils from './util';
import PrismModal from './components/prism/modal/prismModal';
import PrismInput from './components/prism/FormElements/PrismInput';
import FormsyPrismInput from './components/prism/FormsyElements/FormsyPrismInput';
import PrismLabel from './components/prism/label/prismLabel';
import PrismMessage from './components/prism/message/prismMessage';
import SlideOut from './components/slideout/SlideOut.jsx';
import PrismChip from './components/prism/chip/prismChip';
import PrismIcon from './components/prism/icon/prismIcon';
import PrismTooltip from './components/prism/tooltip/prismTooltip';
import PrismCodePicker from './components/prism/FormElements/PrismCodePicker';
import FormsyPrismCodePicker from './components/prism/FormsyElements/FormsyPrismCodePicker';
import JsonViewer from './components/JsonViewer/JsonViewer';
import PrismIndicatorFlag from './components/prism/indicator/prismIndicatorFlag';
import PrismSpinner from './components/prism/spinner/prismSpinner';
import FormsyPrismCheckbox from './components/prism/FormsyElements/FormsyPrismCheckbox';
import FormsyPrismRadioButton from './components/prism/FormsyElements/FormsyPrismRadioButton'
import FormsyPrismRadioGroup from './components/prism/formsy/formsyPrismRadioGroup';
import PrismSwitch from './components/prism/switch/prismSwitch';
import FormsyDatetime from './components/formsyDatetime';
import InputInteractive from './components/prism/FormElements/InputInteractive';
import FormsyInputInteractive from './components/prism/FormsyElements/FormsyInputInteractive';
import ValidationEmails from './components/ValidationEmails.jsx';
import ManheimHeader from './components/Manheim/Header';


module.exports = (function () {
    /* private properties and methods */
    let me = {};

    /* public properties and methods */

    /* shared components */
    me.getInLineLoader = loaders.getInLineLoader;
    me.getLoader = loaders.getLoader;
    me.getFullScreenLoader = loaders.getFullScreenLoader;
    me.fullScreenLoader = me.getFullScreenLoader();
    me.loader = me.getLoader();
    me.AppContainer = require("./components/appContainer.jsx")();
    me.Header = require("./components/header.jsx")();
    me.Footer = require("./components/footer.jsx")();
    me.Login = require("./components/login.jsx")();
    me.SSOPortal = require("./components/ssoportal.jsx")();
    me.OAuthCallback = initOAuthCallback();
    me.Splash = require("./components/splash.jsx")();
    me.UpdateSecuritySettings = require("./components/updateSecuritySettings.jsx")();
    me.ResetPassword = require("./components/resetPassword.jsx")();
    me.ForgotPassword = require("./components/forgotPassword.jsx")();
    me.ForgotUsername = require("./components/forgotUsername.jsx")();
    me.Register = require("./components/register.jsx")();
    me.PageAlerts = require("./components/pageAlerts.jsx")();
    me.Ping = require("./components/ping.jsx")();
    me.Vdp = require("./components/vdp.jsx")();
    me.VehicleSummary = require("./components/vehicleSummary.jsx")();
    me.VehicleDetail = require("./components/vehicleDetail.jsx")();
    me.CodePicker = require("./components/codePicker.jsx")();
    me.StyledCheckbox = require("./components/styledCheckbox.jsx");
    me.StyledRadio = require("./components/styledRadio.jsx");
    me.JSONEditor = require("./components/jsonEditor.jsx");
    me.FormError = require("./components/formError.jsx");
    me.FormsyFormErrorsProvider = require('./components/formsyFormErrorsProvider.jsx');
    me.Modal = require("./components/modal.jsx")();
    me.Prompt = require("./components/prompt.jsx")();
    me.TimeoutPrompt = require("./components/timeoutPrompt.jsx")();
    me.DevPanel = require("./components/devPanel.jsx")();
    me.Grid = require("./components/grid.jsx");
    me.DynamicForm = require("./components/dynamicForm.jsx")();
    me.Searchbox = require("./components/searchbox.jsx");
    me.Paiger = require("./components/paiger.jsx");
    me.Sorter = require("./components/sorter.jsx")();
    me.InfiniteScroll = require("./components/infiniteScroll.jsx");
    me.ImageGalleryModal = require("./components/imageGalleryModal.jsx");
    me.PageModalContent = require("./components/pageModalContent.jsx")();
    me.ValidatedForm = require("./components/ValidatedForm.jsx");
    me.ContentModal = require("./components/contentModal.jsx")();
    me.PropsFormError = require("./components/propsFormError.jsx");
    me.UnsavedChangesPrompt = UnsavedChangesPrompt;

    me.OpsNav = require("./components/ops/opsNav.jsx")();
    me.OpsHeader = require("./components/ops/opsHeader.jsx")();
    me.OpsFooter = require("./components/ops/opsFooter.jsx");

    me.StatusLoader = require('./components/statusLoader.jsx');
    me.WorkflowState = require('./workflow/FlexWorkflowState')();
    me.ExportDownload = require('./components/exportDownload')(utils);
    me.Error = require('./components/error.jsx')();
    me.HorizontallyScrollableByMouse = require('./components/horizontallyScrollableByMouse.jsx').default;
    me.LoadingArea = require('./components/loadingArea.jsx').default;

    me.PrismIcon = require('./components/prism/icon/prismIcon.jsx').default;
    me.PrismLink = require('./components/prism/link/prismLink.jsx').default;
    me.PrismButton = require('./components/prism/button/prismButton.jsx').default;
    me.PrismButtonGroup = require('./components/prism/buttonGroup/prismButtonGroup.jsx').default;
    me.SlideOut = require('./components/prism/buttonGroup/prismButtonGroup.jsx').default;
    me.PrismCheckbox = require('./components/prism/checkbox/prismCheckbox.jsx').default;
    me.PrismSearch = require('./components/prism/search/prismSearch.jsx').default;
    me.PrismSort = require('./components/prism/sort/prismSort.jsx').default;
    me.PrismSpinner = require('./components/prism/spinner/prismSpinner.jsx').default;
    me.PrismPaiger = require('./components/prism/paiger/prismPaiger.jsx').default;
    me.PrismPageSizePicker = require('./components/prism/PageSizePicker/PrismPageSizePicker.jsx').default();
    me.PrismGrid = require('./components/prism/Grid/prismGrid.jsx').default();

    me.HOC = {
        Toggleable: require('./components/hoc/toggleable'),
        WithModal: require('./components/hoc/WithModal')(),
        WithTermsAndConditions: require('./components/hoc/withTermsAndConditions')()
    };
    me.Modals = {
        AddEditLocation: require('./components/modals/AddEditLocation')(),
        ContactMe: require('./components/modals/ContactMe')(),
        SubmitModal,
        PrismSubmitModal,
        InfoModal,
        SpinnerModal
    }

    me.CronFormatter = CronFormatter;
    me.PrismModal = PrismModal;
    me.PrismInput = PrismInput;
    me.FormsyPrismInput = FormsyPrismInput;
    me.PrismLabel = PrismLabel;
    me.PrismMessage = PrismMessage;
    me.SlideOut = SlideOut;
    me.PrismChip = PrismChip;
    me.PrismIcon = PrismIcon;
    me.PrismTooltip = PrismTooltip;
    me.PrismSwitch = PrismSwitch;
    me.PrismCodePicker = PrismCodePicker;
    me.FormsyPrismCodePicker = FormsyPrismCodePicker;
    me.JsonViewer = JsonViewer;
    me.PrismIndicatorFlag = PrismIndicatorFlag;
    me.PrismSpinner = PrismSpinner;
    me.FormsyPrismCheckbox = FormsyPrismCheckbox;
    me.FormsyPrismRadioButton = FormsyPrismRadioButton;
    me.FormsyPrismRadioGroup = FormsyPrismRadioGroup;
    me.FormsyDatetime = FormsyDatetime;
    me.InputInteractive = InputInteractive;
    me.FormsyInputInteractive = FormsyInputInteractive;

    me.ValidationEmails = ValidationEmails;

    me.ManheimHeader = require('./components/Manheim/Header')();
    me.ManheimFooter = require('./components/Manheim/Footer')();

    return me;
}());
